import { render, staticRenderFns } from "./commonFeedback.vue?vue&type=template&id=fc93e7ec&scoped=true"
import script from "./commonFeedback.vue?vue&type=script&lang=js"
export * from "./commonFeedback.vue?vue&type=script&lang=js"
import style0 from "./commonFeedback.vue?vue&type=style&index=0&id=fc93e7ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc93e7ec",
  null
  
)

export default component.exports